export default "__VITE_ASSET__Cdkf5UCw__"